import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/ComingSoon.css';

const ComingSoon = () => {
  return (
    <div className="coming-soon">
      <div className="coming-soon-content">
        <div className="launching-badge">Coming Soon</div>
        <h1>We're Launching Soon!</h1>
        <p>Our team is working hard to bring you an exceptional experience. Please check back later.</p>
        <Link to="/" className="back-home">
          ← Back to Home
        </Link>
      </div>
    </div>
  );
};

export default ComingSoon;
